import { SxProps } from '@mui/material';
import theme from '../../../theme';

export const styles: Record<string, SxProps> = {
  mobileStepper: {
    mb: 7,
    '.MuiMobileStepper-progress': {
      width: '100%',
      height: '6px',
      backgroundColor: theme.palette.paleBlue.main,
      borderRadius: '3px',
    },
    '.MuiLinearProgress-bar': {
      backgroundColor: theme.palette.tertiary.main,
      borderRadius: '3px',
    },
  },
};
